var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLadderSimple = function SvgIconLadderSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 2a1 1 0 0 1 1 1v2.75h10V3a1 1 0 1 1 2 0v18a1 1 0 1 1-2 0v-2.75H7V21a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m1 14.25h10V13H7zm10-8.5V11H7V7.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLadderSimple;